import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';


@Component({
  selector: 'app-emitir-retencion-compra-modal',
  templateUrl: './emitir-retencion-compra-modal.component.html',
  styleUrls: ['./emitir-retencion-compra-modal.component.css']
})
export class EmitirRetencionCompraModalComponent implements OnInit {
  @Input() compra_id: String;
  @Output() cerrarModal = new EventEmitter();
  constructor(
    public bsModalRef: BsModalRef,
  ) { }

	ngOnInit() {
	}

	onCerrarModal(event){
		if(event.isSaved){
			this.cerrarModal.emit({isSaved: true});
		}
		if(event.close){
			this.bsModalRef.hide();
		}
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/emitir-retencion-compra-modal/emitir-retencion-compra-modal.component.ts